export const serviceIdentifiers = {
    IFirebaseService: Symbol.for("IFirebaseService"),
    IAnalyticsService: Symbol.for("IAnalyticsService"),
    IIFrameBrowserService: Symbol.for("IIFrameBrowserService"),
    INavigationService: Symbol.for("INavigationService"),
    IGameCanvasStylingService: Symbol.for("IGameCanvasStylingService"),
    AuthenticationInitiator: Symbol.for("AuthenticationInitiator"),
    ExitConfirmationService: Symbol.for("ExitConfirmationService"),
};
